module.exports = __webpack_public_path__ + "img/s1.08f83f53.png";